<template>
    <div class="switch-button">
        <simple-button :class="{ inline: inline && !option.selected, selected: option.selected }" v-for="option in internalOptions" @press="select(option)">{{option.caption}}</simple-button>
    </div>
</template>

<script>
    import SimpleButton from "./SimpleButton";
    export default {
        name: "SwitchButton",
        components: {SimpleButton},
        props: {
            options: Array,
            value: String,
            inline: Boolean
        },
        data: function() {
            return {
                internalOptions: []
            }
        },
        methods: {
            select(option) {
                if(option.selected == true) {
                    option.selected = false;
                    this.$emit('input', "");
                    this.$emit('selected', "");
                    return;
                }
                this.internalOptions.forEach(opt => this.$set(opt, 'selected', false));
                this.$set(option, 'selected', true);
                this.$emit('selected', option.value);
                this.$emit('input', option.value);
            }
        },
        watch: {
            options: {
                handler(newVal) {
                    this.internalOptions = this.$_.cloneDeep(newVal);
                    this.internalOptions.forEach(option => this.$set(option, 'selected', false));
                },
                immediate: true
            },
            value: {
                handler(newVal, oldValues) {
                    this.internalOptions
                        .forEach(option => {
                            if(option.value == newVal) {
                                option.selected = true
                            }
                            else {
                                option.selected = false
                            }
                        });
                },
                immediate: true
            }
        }
    }
</script>

<style scoped lang="scss">
.switch-button {
    display: flex;
    flex-flow: row;
    width: min-content;
}

.switch-button>* {
    margin-left: 1px;
}

.switch-button:first-child {
    margin-left: 0px;
}

    .selected {
        background: linear-gradient(to bottom, #ffaf34 5%, #ffe98e 100%);
        color: var(--background-color);
    }

    .selected:hover {
        background: linear-gradient(to bottom, #ffaf34 5%, #ffe98e 100%);
        color: var(--background-color);
    }

    .inline {
        color: var(--input-font-color);
        background: transparent !important;
    }
</style>